import "./whatsapp.css";
import { useNavigate } from "react-router-dom";

const WhatsAppButton = () => {
  const phoneNumber = "919495958871";
  const mobileNumber = "+919495958871";
  const navigate = useNavigate();

  const handlePhoneCall = () => {
    window.location.href = `tel:${mobileNumber}`;
  };

  const handleEnquiry = () => {
    navigate("/contact");
  };

  return (
    <>
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${phoneNumber}`}
        className="wa-root wa-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        {/* Tooltip */}
        <span className="wa-tooltip">Chat with us</span>
        {/* Pulse rings */}
        <span className="wa-ring wa-ring-1" aria-hidden="true" />
        <span className="wa-ring wa-ring-2" aria-hidden="true" />

        {/* WhatsApp SVG icon */}
        <svg
          className="wa-icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M16 2C8.268 2 2 8.268 2 16c0 2.49.648 4.83 1.782 6.86L2 30l7.338-1.762A13.93 13.93 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 0 1-5.834-1.596l-.418-.248-4.354 1.046 1.068-4.24-.272-.434A11.46 11.46 0 0 1 4.5 16C4.5 9.596 9.596 4.5 16 4.5S27.5 9.596 27.5 16 22.404 27.5 16 27.5zm6.29-8.61c-.344-.172-2.036-1.004-2.352-1.118-.316-.116-.546-.172-.776.172s-.892 1.118-1.092 1.348c-.2.23-.4.258-.744.086-.344-.172-1.452-.536-2.766-1.708-1.022-.912-1.712-2.038-1.912-2.382-.2-.344-.022-.53.15-.702.154-.154.344-.4.516-.6.172-.2.23-.344.344-.574.116-.23.058-.43-.028-.602-.086-.172-.776-1.872-1.064-2.562-.28-.67-.564-.58-.776-.59l-.66-.012c-.23 0-.602.086-.918.43s-1.204 1.176-1.204 2.868 1.232 3.328 1.404 3.558c.172.23 2.426 3.706 5.878 5.194.822.354 1.464.566 1.964.724.824.262 1.574.224 2.168.136.66-.098 2.036-.832 2.322-1.636.288-.804.288-1.492.202-1.636-.086-.144-.316-.23-.66-.4z"
            fill="currentColor"
          />
        </svg>
      </a>

      {/* Phone Button */}
      <button
        onClick={handlePhoneCall}
        className="wa-root wa-phone"
        aria-label="Call us"
      >
        <span className="wa-tooltip">Call us</span>
        <span className="wa-ring wa-ring-1" aria-hidden="true" />
        <span className="wa-ring wa-ring-2" aria-hidden="true" />

        {/* Phone Icon SVG */}
        <svg
          className="wa-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .82h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
        </svg>
      </button>

      {/* Enquiry Button */}
      <button
        onClick={handleEnquiry}
        className="wa-root wa-enquiry"
        aria-label="Send Enquiry"
      >
        <span className="wa-tooltip">Send Enquiry</span>
        <span className="wa-ring wa-ring-1" aria-hidden="true" />
        <span className="wa-ring wa-ring-2" aria-hidden="true" />

        {/* Enquiry/Email Icon SVG */}
        <svg
          className="wa-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      </button>
    </>
  );
};

export default WhatsAppButton;
